import axios from "axios";

let siteURL = typeof DASHBOARD_URL !== 'undefined' ? DASHBOARD_URL : 'https://app.locaboo.com/';
let widgetPublicId = typeof WIDGET_PUBLIC_ID !== 'undefined' && WIDGET_PUBLIC_ID ? WIDGET_PUBLIC_ID : null;
let widgetNonce = typeof WIDGET_NONCE !== 'undefined' && WIDGET_NONCE ? WIDGET_NONCE : null;

/** For local development purpose */
if (!true) {
    siteURL = 'https://admin:1servus1@stage.locaboo.com/';
    widgetPublicId = null;
}

let baseURL = `${siteURL.replace(/\/$/, '')}/api/v2/`

if (process.env.NODE_ENV !== 'production') {
    // baseURL = `http://locaboo.local/api/v2/`
}

const commonParams = {
    'widget_public_id': widgetPublicId,
    'widget_nonce': WIDGET_NONCE, // to secure the API call
    'configurator': true
}

const apiClient = axios.create({
    baseURL,

    withCredentials: false,

    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },

    params: commonParams
})

export default {

    getEventTypes: () => apiClient.get('event_configurator/step_1'),

    getPersonFreeText: () => apiClient.get('event_configurator/step_2'),

    getSeatTypes: () => apiClient.get('event_configurator/step_3'),

    getResourceAvailability: params => apiClient.get('availability', {params}),

    getInventories: resource_id => apiClient.get('inventory_list', {params: {resource_id}}),

    getServices: resource_id => apiClient.get('service_list', {params: {resource_id}}),

    getOverNightStayOfferFreeText: () => apiClient.get('event_configurator/step_8'),

    getAdditionalCommentFreeText: () => apiClient.get('event_configurator/step_9'),

    getResource: id => apiClient.get(`resource/${id}`),

    calculatePrice: params => apiClient.get(`event_configurator/calculate_price`, {params}),

    // saveConfigurator: params => apiClient.post(`event_configurator/save-api`, params),

    saveConfigurator: async (params) => {
        const response = await fetch(`${baseURL}event_configurator/save?${Object.keys(commonParams).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(commonParams[k])).join('&')}`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            // mode: 'no-cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'omit', // include, *same-origin, omit
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(params) // body data type must match "Content-Type" header
        });

        return response.ok ? response.json() : null;
    }

}


// WEBPACK FOOTER //
// ./src/services/api.service.js